var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "item-container" }, [_vm.resource.type === _vm.TabsType.AUDIO ? _c('audio-container', { ref: "audioContainer", attrs: { "url": _vm.resource.file_url, "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        tag_ids: _vm.resource.tag_ids,
        format: _vm.resource.file_meta.format,
        fileSize: _vm.resource.file_meta.file_size,
        updated_time: _vm.resource.updated_time,
        duration: _vm.setDuration
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "audioStyle": _vm.imageStyle, "autoPlayWhenHover": true } }) : _vm._e(), _vm._v(" "), _vm.resource.type === _vm.TabsType.VIDEO ? _c('video-container', { attrs: { "url": _vm.resource.file_url, "cover": _vm.resource.thumb_url, "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        width: _vm.resource.file_meta.width,
        height: _vm.resource.file_meta.height,
        tag_ids: _vm.resource.tag_ids,
        updated_time: _vm.resource.updated_time,
        duration: _vm.setDuration
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "videoStyle": _vm.imageStyle } }) : _vm._e(), _vm._v(" "), _vm.resource.type === _vm.TabsType.PICTURE || _vm.resource.type === _vm.TabsType.FONT || _vm.resource.type === _vm.TabsType.KEEL || _vm.resource.type === _vm.TabsType.PARTICLE || _vm.resource.type === _vm.TabsType.FLOWERWORD || _vm.resource.type === _vm.TabsType.FILTER || _vm.resource.type === _vm.TabsType.TRANSITION || _vm.resource.type === _vm.TabsType.ANIMATION || _vm.resource.type === _vm.TabsType.PRESETS || _vm.activeTab === _vm.TabsType.FRAGMENT || _vm.resource.type === _vm.TabsType.MODEL || _vm.resource.type === _vm.TabsType.ACTION || (_vm.resource.file_meta && _vm.resource.file_meta.format) === 'gif' ? _c('image-container', { attrs: { "url": _vm.setImgUrl, "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        width: _vm.resource.file_meta && _vm.resource.file_meta.width || 200,
        height: _vm.resource.file_meta && _vm.resource.file_meta.height || 200,
        updated_time: _vm.resource.updated_time,
        tag_ids: _vm.resource.tag_ids
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "imageStyle": _vm.imageStyle } }) : _vm._e(), _vm._v(" "), _vm.resource.type === _vm.TabsType.GRAPH && _vm.resource.file_meta.format === 'zip' ? _c('sequence-frame-container', { attrs: { "images": _vm.resource.preview_urls || [], "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        width: _vm.resource.file_meta.width,
        height: _vm.resource.file_meta.height,
        fileSize: _vm.resource.file_meta.file_size,
        updated_time: _vm.resource.updated_time
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "frame-sequence-container-style": _vm.imageStyle, "frame-sequence-style": {
        width: _vm.resource.file_meta.width / 2 + 'px',
        height: _vm.resource.file_meta.height / 2 + 'px'
      } } }) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };